module.exports = __webpack_public_path__ + "media/images/flags/gq-ad0ccfc211d4dd2eed87ba72518dd96b.svg";